module.exports = __webpack_public_path__ + "static/media/animal-cat2.efc4b1c5.aac";